<div class="map-buttons" *ngIf="!isNative">
  <button type="button" class="cnt-button" (click)="close.emit()">
    <div class="cnt-button-copy">
      {{ text }}
    </div>
  </button>

  <button type="button" class="cnt-button close-map" (click)="close.emit()">
    <div class="cnt-button-copy">
      <i class="icon-cnt-times"></i>
    </div>
  </button>
</div>
<div class="map-square">
  <div #mapContainer class="square-map-container">
    <curbnturf-here-map
      #heremap
      [lat]="location?.lat"
      [lon]="location?.lon"
      [zoom]="zoom"
      [showCurrentLocation]="false"
      [addPoiMode]="true"
      [draggable]="draggable"
      [pins]="pins"
      (mapTapped)="newPosition($event)"
      (drag)="updateCoordinates($event)"
      (dragEnd)="newPosition($event)"
      type="satellite"
    >
    </curbnturf-here-map>
    <pre></pre>
    <button type="button" *ngIf="!isNative" class="done-button close-map cnt-button" (click)="close.emit()">
      <div class="cnt-button-copy">Done</div>
    </button>
  </div>
</div>
